import { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { FormattedMessage } from "react-intl";
import { useGetCompanyBasicSettings, useUpdateCompanyBasicSettings } from "../../../../hooks/CompanyAdmin/companyBasicSettings";
import CompanyVisibilityEditor from "./CompanyVisibilityEditor";

const CompanyVisibility = ({ classes = {}, targetCompanyId }) => {
  const alert = useAlert();

  const [visibility, setVisibility] = useState();

  const [getSettings, { loading: fetching }] = useGetCompanyBasicSettings();
  const [updateSettings, { loading: updating }] = useUpdateCompanyBasicSettings();

  const initializeVisibility = (value) => {
    setVisibility(value);
  };

  const handleSave = async (newVisibility) => {
    await updateSettings({
      settings: {
        companyId: targetCompanyId,
        visibility: newVisibility,
      },
      onError: () => {
        alert.error(<FormattedMessage id="common.genericErrorMessage" />);
      },
      onSuccess: (settings) => {
        initializeVisibility(settings.visibility);
      },
    });
  };

  useEffect(() => {
    if (targetCompanyId) {
      getSettings({
        companyId: targetCompanyId,
        onSuccess: (settings) => {
          initializeVisibility(settings.visibility);
        },
      });
    }
  }, [targetCompanyId]);

  return (
    <CompanyVisibilityEditor
      classes={classes}
      disabled={fetching || updating}
      onSave={handleSave}
      visibility={visibility}
    />
  );
};

export default CompanyVisibility;
